import { render, staticRenderFns } from "./VNewBudgetForm.vue?vue&type=template&id=0dcc96da&"
import script from "./VNewBudgetForm.vue?vue&type=script&lang=js&"
export * from "./VNewBudgetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports